import styled from 'styled-components';

export const ManageHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;

  @media (max-width: 588px) {
    margin-left: -200px;
    padding-left: 255px;
  }

  @media (max-width: 1170px) {
    justify-content: center;
    flex-direction: column;
    padding-bottom: 360px;
    margin-bottom: -350px;
    align-items: center;
    overflow-x: auto;

    & > div:first-of-type {
      margin-bottom: 10px;
    }
  }
`;

export const ManageHeaderLeft = styled.div`
  display: flex;
`;

export const ManageHeaderWrapper = styled.div`
  margin: 0 5px;
`;
